"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientFeatures = void 0;
const PermissionName_1 = require("../Permission/PermissionName");
const NativeFeatureIdentifier_1 = require("../Feature/NativeFeatureIdentifier");
const domain_core_1 = require("@standardnotes/domain-core");
function clientFeatures() {
    return [
        {
            name: 'Tag Nesting',
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.TagNesting,
            permission_name: PermissionName_1.PermissionName.TagNesting,
            description: 'Organize your tags into folders.',
        },
        {
            name: 'Smart Filters',
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SmartFilters,
            permission_name: PermissionName_1.PermissionName.SmartFilters,
            description: 'Create smart filters for viewing notes matching specific criteria.',
        },
        {
            name: 'Encrypted files',
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.Files,
            permission_name: PermissionName_1.PermissionName.Files,
            description: '',
        },
        {
            name: 'Clipper',
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.Clipper,
            permission_name: PermissionName_1.PermissionName.Clipper,
            description: '',
        },
    ];
}
exports.clientFeatures = clientFeatures;
